import {
    TransactionAction,
    TransactionsActions,
} from '../actions/transactions.actions';
import { StaticUserData } from '../models/static-user-data.model';
import { StaticUserDataState } from '../state/static-user-data.state';

export const initialStaticUserDataState: StaticUserDataState = {
    null: {
        userId: '',
        email: '',
        firstName: '',
        lastName: '',
        country: '',
        merchant: '',
    },
};

export function staticUserDataReducer(
    state = initialStaticUserDataState,
    action: TransactionAction
) {
    switch (action.type) {
        case TransactionsActions.SuccessGetTransaction:
            const newState: StaticUserDataState = { ...state };

            newState[action.transactionId] = {
                ...new StaticUserData(action.actions),
            };

            return newState;
        default:
            return state;
    }
}
